const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const trackEvent = (event) => {
  fetch(`${BACKEND_URL}/api/analytics/track`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ event }),
  }).catch(() => {});
};
